var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nt-message",class:'nt-message_'+_vm.type},[_c('i',{staticClass:"iconfont nt-message__icon",class:_vm.iconClass}),_c('span',{staticClass:"nt-message__txt"},[_vm._v(_vm._s(_vm.content))])])}
var staticRenderFns = []

export { render, staticRenderFns }